/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { manufacturersTableGrid } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

// variables custom Import
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  getCurrentQtr,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { navigateToRequest } from './ConstantData';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
  START_QUATER_REQ,
  QTR_VALIDATION_ERR,
  VALIDATE_QUARTER_VALUE,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  NO_DATA,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  quarterTest1,
  quarterTest2,
  checkQuarterValidation,
  compareQtrs,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchErrorMsgHcpcsCode,
  getPlanTypeValues,
  getRebateProgrameList,
  hcpcsCodeClaimSearchObj,
  getManufacturerList,
  getDetailReportTypeQtrList,
  getSummaryReportTypeQtrList,
  getDetailReportTypeNdcList,
  getSummaryReportTypeMfgList,
  getSelectedOption,
  dispatchSortBy,
  dispatchQtrRange,
  getManufactureName,
  getManufactureID,
  dispatchRebatePrograme,
  dispatchAllMfgChecked,
  setSearchInput,
  dispatchDisplayObjHcpcsClaims,
  getSummaryReportMfgList,
  setExportToAllData,
  setDetailReportTypeQtr,
  setDetailReportTypeNdc,
  setSummaryReportTypeMfg,
  setSummaryReportTypeQtr,
} from '../Store/Action';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { showNoDataMessage } from '../../OutstandingBalanceByLabererAndQuarter/Store/Action';

const HcpcsCodeClaimsPaid = (props) => {
  const dispatch = useDispatch();
  const gridRef = React.useRef();

  // use Selector function
  const {
    selectedRowIndexValue,
    selectedOption,
    sortBy: sortByValue,
  } = useSelector((state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const requestHcpcsCodeScreenData = useSelector(
    (state) =>
      state?.sharedState?.HcpcsCodeClaimsPaidReducer?.hcpcsCodeClaimSearchObj
  );
  const { startQtr: startQtrValue, endQtr: endQtrValue } = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.planType
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.errorMsgHcpcsCode
  );
  const resultManufacturerList = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.manufacturerList
  );
  const isLoading = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.isLoading
  );
  const resultDetailQtrList = useSelector(
    (state) =>
      state?.sharedState?.HcpcsCodeClaimsPaidReducer?.detailQtrSearchData
  );
  const resultDetailNdcList = useSelector(
    (state) =>
      state?.sharedState?.HcpcsCodeClaimsPaidReducer?.detailNdcSearchData
  );
  const resultSummaryQtrList = useSelector(
    (state) =>
      state?.sharedState?.HcpcsCodeClaimsPaidReducer?.summaryQtrSearchData
  );
  const resultSummaryMfgList = useSelector(
    (state) =>
      state?.sharedState?.HcpcsCodeClaimsPaidReducer?.summaryMfgSearchData
  );

  const history = useHistory();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [manufacturerList, setManufacturerList] = React.useState([
    resultManufacturerList?.rebatePercentOfSpendMfgGridVO,
  ]);
  const [curQtr, setCurQtr] = React.useState(getCurrentQtr().join('Q'));
  const [menuName, setMenuName] = React.useState(['ALL']);
  const [manufacturerWithId, setManufactureWithId] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );
  // states with initial values
  const [state, setState] = React.useState(
    requestHcpcsCodeScreenData?.state
      ? requestHcpcsCodeScreenData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          selectedValue: selectedOption,
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          sortBy: sortByValue,
          startQtr: startQtrValue,
          endQtr: endQtrValue,
          allManufacturers: true,
        }
  );

  function convertDateFormat(dateStr) {
    const year = dateStr?.substr(2);
    const quarter = dateStr?.substr(0, 1);
    const convertedStr = year + quarter;
    return convertedStr;
  }
  const nStartQtr = convertDateFormat(state?.startQtr);
  const nEndQtr = convertDateFormat(state?.endQtr);
  const nCurQtr = convertDateFormat(curQtr);
  // dispatch function
  const setHcpcsCodeClaimScrData = (value) =>
    dispatch(hcpcsCodeClaimSearchObj(value));

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  // React.useEffect(() => {
  //   setselectedValue(selectedOption);
  // }, [selectedOption]);

  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // get rebate program
  React.useEffect(() => {
    if (state.planTypeCd) {
      rebatepgmDropdown(state.planTypeCd);
    }
  }, [state.planTypeCd]);
      
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
  }, []);

  // set Rebate Program List
  const rebatepgmDropdown = async (planType) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(state.planTypeCd)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };

  // Manufacturer Grid From API
  React.useEffect(() => {
    if (state.planTypeCd) {
      setManufacturerList(resultManufacturerList);
    }
  }, [resultManufacturerList]);

  React.useEffect(() => {
    if (state.planTypeCd) {
      dispatch(
        getManufacturerList({
          planType: state.planTypeCd,
          asMode: 1,
        })
      );
    }
  }, [state.planTypeCd]);

  // handle- onchange functionality

  const handleOnChangeEvent = (value, name) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    const newState = _.cloneDeep(state);

    if (
      _.includes(
        [
          'planTypeCd',
          'selectedValue',
          'rebateProgramCd',
          'reportType',
          'sortBy',
        ],
        name
      )
    ) {
      newState[name] = value;
      if (name === 'planTypeCd') {
        newState.rebateProgramCd = '-1';
      }
      if (name === 'selectedValue') {
        // newState.rebateProgramCd = '-1';
        newState.sortBy = 'Quarter';
      }
      setState(newState);
      setHcpcsCodeClaimScrData({
        state: newState,
      });
      const localErr = getErrorMsg?.filter((item) => item.field !== 'noData');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgHcpcsCode(unique));
    }
  };
  const handlefromChange = (event) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    const newState = _.cloneDeep(state);
    newState.startQtr = value;
    setState(newState);
    setHcpcsCodeClaimScrData({
      state: newState,
    });
    const localErr = getErrorMsg
      ?.filter((item) => item.field !== 'startQtr')
      .filter((item) => item.field !== 'noData');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgHcpcsCode(unique));
  };

  const handleOnChange = (event) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    const newState = _.cloneDeep(state);
    newState.endQtr = value;
    setState(newState);
    setHcpcsCodeClaimScrData({
      state: newState,
    });
    const localErr = getErrorMsg?.filter((item) => item.field !== 'endQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgHcpcsCode(unique));
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    let localErr = getErrorMsg || [];

    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    if (type === 'startQtr' || type === 'endQtr') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          setState({ ...state, [type]: autoFormateDate(value?.toUpperCase()) });
          setHcpcsCodeClaimScrData({
            state: { ...state, [type]: autoFormateDate(value?.toUpperCase()) },
          });
          if (type === 'startQtr' && !state?.endQtr) {
            setState((prevState) => ({
              ...prevState,
              endQtr: autoFormateDate(value?.toUpperCase()),
            }));
            setHcpcsCodeClaimScrData({
              state: {
                ...state,
                [type]: autoFormateDate(value?.toUpperCase()),
                endQtr: autoFormateDate(value?.toUpperCase()),
              },
            });
          }
          if (
            checkQuarterValidation(state?.startQtr) &&
            checkQuarterValidation(state?.endQtr)
          ) {
            if (compareQtrs(state?.startQtr, state?.endQtr)) {
              localErr.push({
                field: type,
                errorType: 'rangeInvalid',
                message: QTR_VALIDATION_ERR,
              });
            } else {
              localErr = localErr?.filter(
                (item) => item.errorType !== 'rangeInvalid'
              );
            }
          }
        } else {
          localErr =
            localErr && localErr?.filter((item) => item.field !== type);
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr && localErr?.filter((item) => item.field !== type);
        if (type === 'startQtr') {
          localErr.push({
            field: type,
            errorType: 'startQtrRequired',
            message: START_QUATER_REQ,
          });
        }
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgHcpcsCode(unique));
  };
  // uncheck manufacturer grid
  const checkManufacturer = () => {
    const newCheck = !state?.allManufacturers;
    const newState = _.cloneDeep(state);
    newState.allManufacturers = newCheck;
    setState(newState);
    setHcpcsCodeClaimScrData({
      state: newState,
    });
    if (!state?.allManufacturers)
      onSelectionChanged({}, !state?.allManufacturers);
    let localErr = getErrorMsg || [];
    localErr = localErr
      .filter((item) => item.field != 'nomanufacture')
      .filter((item) => item.field !== 'noData');

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgHcpcsCode(unique));
  };

  // full Screen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Grid functionality

  const [numberOfSelectedRows, setNumberOfSelectedRows] = React.useState(0);
  const onSelectionChanged = (e, isAllChecked) => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    e.api.clearFocusedCell(); 
    if (isAllChecked) {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < manufacturerList.length; i++) {
        selectedMenuName.push(manufacturerList[i]?.mfgName);
        temp.push({
          manufacturerID: manufacturerList[i]?.mfgId,
          manufacturerName: manufacturerList[i]?.mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
    } else {
      const selectedRows = e.api?.getSelectedRows();
      setNumberOfSelectedRows(e.api?.getSelectedRows().length);
      const selectedMfgId = selectedRows?.map((item) => item.mfgId);
      const selectedIndexes = [];
      manufacturerList
        .sort((a, b) => (a.mfgId > b.mfgId ? 1 : -1))
        .forEach((item, index) => {
          if (selectedMfgId?.indexOf(item.mfgId) != -1) {
            selectedIndexes.push(index);
          }
        });
      setSelectedRowIndex(selectedIndexes);
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < selectedRows.length; i++) {
        selectedMenuName.push(selectedRows[i].mfgName);
        temp.push({
          manufacturerID: selectedRows[i].mfgId,
          manufacturerName: selectedRows[i].mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
      setSelectedRows(selectedRows);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field != 'nomanufacture');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgHcpcsCode(unique));
    }
  };

  React.useEffect(() => {
    const isAllSelected = state?.allManufacturers;
    if (isAllSelected) {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < manufacturerList.length; i++) {
        selectedMenuName.push(manufacturerList[i]?.mfgName);
        temp.push({
          manufacturerID: manufacturerList[i]?.mfgId,
          manufacturerName: manufacturerList[i]?.mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
    }
  }, [manufacturerList]);

  const getSelectedRowData = () => {
    const selectedData = this.gridApi.getSelectedRows();
    return selectedData;
  };

  // Search button on click functionality
  const onClickOnSearch = async () => {
    dispatch(dispatchErrorMsgHcpcsCode([]));
    setSearchClicked(false);
    dispatch(setDetailReportTypeQtr([]));
    dispatch(setDetailReportTypeNdc([]));
    dispatch(setSummaryReportTypeQtr([]));
    dispatch(setSummaryReportTypeMfg([]));
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    )?.rebateProgramCd;
    const rebateProgrameName = rebateProgramList?.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr =  [];
    const sRows =
      (state?.allManufacturers ? manufacturerList : selectedRows) || [];

    if (sRows.length == 0) {
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    let startQtrRequired = false;
    let endQtrRequired = false;
    if (!state?.startQtr) {
      startQtrRequired = true;
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'startQtrRequired',
        message: START_QUATER_REQ,
      });
    }

    if (state?.endQtr.length > 0 && !checkQuarterValidation(state?.endQtr)) {
      endQtrRequired = true;

      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'endQtr',
        errorType: 'endQtrRequired',
        message: VALIDATE_QUARTER_VALUE,
      });
    }

    if (
      !endQtrRequired &&
      !startQtrRequired &&
      checkQuarterValidation(state?.startQtr) &&
      checkQuarterValidation(state?.endQtr)
    ) {
      if (compareQtrs(state?.startQtr, state?.endQtr)) {
        localErr.push({
          field: 'endQtr',
          errorType: 'rangeInvalid',
          message: QTR_VALIDATION_ERR,
        });
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgHcpcsCode(unique));

    if (unique.length > 0 || sRows.length === 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }
    if (unique.length == 0 && sRows.length > 0) {
      let response;
      if (state?.allManufacturers && state?.selectedValue === 'Detail') {
        response = await dispatch(
          getSummaryReportMfgList({
            asRpc: state.rebateProgramCd,
            asStartQtr: state?.startQtr,
            // ? `${state?.startQtr.split('Q')?.[1]}${
            //     state?.startQtr.split('Q')?.[0]
            //   }`
            // : state?.startQtr,
            asEndQtr: state?.endQtr,
            // ? `${state?.endQtr.split('Q')?.[1]}${
            //     state?.endQtr.split('Q')?.[0]
            //   }`
            // : state?.endQtr,
            asMfg: [],
            an_all: 1,
            an_allclaim: 1,
          })
        );
        if (!response.length) {
          dispatch(
            dispatchErrorMsgHcpcsCode([{ field: 'noData', message: NO_DATA }])
          );
          return;
        }
      }
      setSearchClicked(true);

      dispatch(
        setSearchInput({
          selectedRowIndexValue: selectedRowIndex,
          rebateProgramName,
        })
      );
      const nSQ = state.startQtr;
      const nEQ = state.endQtr;
      dispatch(dispatchSortBy(state?.sortBy));
      dispatch(dispatchQtrRange({ nSQ, nEQ }));
      dispatch(dispatchAllMfgChecked(state?.allManufacturers));
      dispatch(getManufactureName(menuName));
      dispatch(
        getManufactureID(
          state?.allManufacturers && state?.selectedValue === 'Detail'
            ? manufacturerWithId.filter(
                (obj) => response.indexOf(obj.manufacturerID) !== -1
              )
            : manufacturerWithId
        )
      );
      dispatch(getSelectedOption(state?.selectedValue));
      dispatch(
        dispatchDisplayObjHcpcsClaims({
          displayObj: {
            isMfgChecked: state?.allManufacturers,
            selectedOption: state?.selectedValue,
            sortBy: state?.sortBy,
            startQtr: state?.startQtr,
            endQtr: state?.endQtr,
            manufactureWithIds:
              state?.allManufacturers && state?.selectedValue === 'Detail'
                ? manufacturerWithId.filter(
                    (obj) => response.indexOf(obj.manufacturerID) !== -1
                  )
                : manufacturerWithId,
            rebateProgramName: rebateProgramName,
            rebateProgrameName,
            allManufacturer: menuName,
            selectedRowIndexValue: selectedRowIndex,
          },
        })
      );
      // mfg grid api
      const manufacturer = manufacturerWithId.map(
        (item) => item.manufacturerID
      );
      const all = ['ALL'];
      const isAllSelected =
        state?.allManufacturers ||
        sRows.length === resultManufacturerList.length;
      // API Calls for Detail Type Qtr
      if (state?.selectedValue === 'Detail' && state?.sortBy === 'Quarter') {
        if (sRows.length === 1) {
          dispatch(
            getDetailReportTypeQtrList(
              {
                asRpc: state.rebateProgramCd,
                asStartQtr: nStartQtr,
                asEndQtr: nEndQtr || nCurQtr,
                asMfg:
                  state?.allManufacturers ||
                  sRows.length === resultManufacturerList.length
                    ? all
                    : manufacturer,
                an_all:
                  state?.allManufacturers ||
                  sRows.length === resultManufacturerList.length
                    ? 1
                    : 0,
                an_allclaim: 1,
              },
              manufacturer
            )
          );
        }
      }
      // API Calls for Detail Type NDC
      if (state?.selectedValue === 'Detail' && state?.sortBy === 'NDC') {
        if (sRows.length === 1) {
          dispatch(
            getDetailReportTypeNdcList(
              {
                asRpc: state.rebateProgramCd,
                asStartQtr: nStartQtr,
                asEndQtr: nEndQtr || nCurQtr,
                asMfg:
                  state?.allManufacturers ||
                  sRows.length === resultManufacturerList.length
                    ? all
                    : manufacturer,
                an_all:
                  state?.allManufacturers ||
                  sRows.length === resultManufacturerList.length
                    ? 1
                    : 0,
                // asMfg: state?.allManufacturers ? all : manufacturer,
                // an_all: state?.allManufacturers == true ? 1 : 0,
                an_allclaim: 1,
              },
              manufacturer
            )
          );
        }
      }

      // API Calls for Summary Type Qtr

      if (state?.selectedValue === 'Summary' && state?.sortBy === 'Quarter') {
        const manufacturer1 = sRows.map((item) => item.mfgId);
        if (sRows.length === 1) {
          dispatch(
            getSummaryReportTypeQtrList({
              asRpc: state.rebateProgramCd,
              asStartQtr: nStartQtr,
              asEndQtr: nEndQtr || nCurQtr,
              asMfg:
                state?.allManufacturers ||
                sRows.length === resultManufacturerList.length
                  ? all
                  : manufacturer1,
              an_all:
                state?.allManufacturers ||
                sRows.length === resultManufacturerList.length
                  ? 1
                  : 0,
              // asMfg: state?.allManufacturers ? all : manufacturer1,
              // an_all: state?.allManufacturers == true ? 1 : 0,
              an_allclaim: 1,
            })
          );
        }
      }

      // API Calls for Summary Type Mfgr
      if (
        state?.selectedValue === 'Summary' &&
        state?.sortBy === 'Manufacturer'
      ) {
        const manufacturer1 = sRows.map((item) => item.mfgId);
        if (sRows.length === 1) {
          dispatch(
            getSummaryReportTypeMfgList({
              asRpc: state.rebateProgramCd,
              asStartQtr: nStartQtr,
              asEndQtr: nEndQtr || nCurQtr,
              asMfg:
                state?.allManufacturers ||
                sRows.length === resultManufacturerList.length
                  ? all
                  : manufacturer1,
              an_all:
                state?.allManufacturers ||
                sRows.length === resultManufacturerList.length
                  ? 1
                  : 0,
              // asMfg: state?.allManufacturers ? all : manufacturer1,
              // an_all: state?.allManufacturers == true ? 1 : 0,
              an_allclaim: 1,
            })
          );
        }
      }
      if (sRows.length > 0 && sRows.length != 1) {
        dispatch(setExportToAllData([]));
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/displayHcpcsCode',
          value: 'Display HCPCS Code Claims Paid',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        props.history.push({
          pathname: '/displayHcpcsCode',
        });
        dispatch(clearReduxForFilterAndSort('/displayHcpcsCode'));
      }
    }
  };

  // For No Data validation
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

  if (
    isSearchClicked &&
    (resultDetailQtrList?.length > 0 ||
      resultDetailNdcList?.length > 0 ||
      resultSummaryQtrList?.length > 0 ||
      resultSummaryMfgList?.length > 0)
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayHcpcsCode',
      value: 'Display HCPCS Code Claims Paid',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayHcpcsCode',
    });
    dispatch(clearReduxForFilterAndSort('/displayHcpcsCode'));
  }
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Req HCPCS Code Claims Paid"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              id="filter-plan-by-radio-btn-action"
              data-testid="chip-cshcn-Rebate-Program"
              labelName={commonConstant.radioGroupLabelNamePlan}
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div
            className="col-md-4"
            // style={{ paddingRight: '10px', paddingTop: '10px' }}
          >
            <RadioGroupComponent
              data-testid="repotyType"
              id="repotyType"
              labelName="Report Type"
              required
              optionList={[
                { name: 'Detail', value: 'Detail' },
                { name: 'Summary', value: 'Summary' },
              ]}
              defaultValue={state && state.selectedValue}
              filterAction={(e) => handleOnChangeEvent(e, 'selectedValue')}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    id="rebate_program"
                    data-testid="req-hcpcs-claims-rbt"
                    label="rebate_program"
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList?.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div className="row">
          <div className="col-4" style={{ paddingTop: '10px' }}>
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Quarter Range <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form input-md field-xl">
                  <div className="sub-radio no-margin">
                    <RadioGroup row name="quarter-range">
                      <Grid container spacing={2}>
                        <Grid item xs={6} className="mandate-fields">
                          <TextField
                            label="Start"
                            id="Start"
                            placeholder=""
                            data-testid="req-hcpcs-claims-start"
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={state?.startQtr}
                            onChange={handlefromChange}
                            onBlur={(e) =>
                              handleOnblurEvent('startQtr', e.target.value)
                            }
                            name="start"
                            error={getErrorMsg?.some((x) => {
                              return x.field === 'startQtr';
                            })}
                            helperText={
                              getErrorMsg?.some((x) => {
                                return x.field === 'startQtr';
                              })
                                ? getErrorMsg?.find((x) => {
                                    return x.field === 'startQtr';
                                  })?.message
                                : null
                            }
                          />
                        </Grid>
                        <Grid item xs={6} className="mandate-fields">
                          <TextField
                            label="End"
                            id="End"
                            placeholder=""
                            data-testid="req-hcpcs-claims-end"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10 }}
                            name="end"
                            value={state?.endQtr}
                            onChange={handleOnChange}
                            onBlur={(e) =>
                              handleOnblurEvent('endQtr', e.target.value)
                            }
                            error={getErrorMsg?.some((x) => {
                              return x.field === 'endQtr';
                            })}
                            helperText={
                              getErrorMsg?.some((x) => {
                                return x.field === 'endQtr';
                              })
                                ? getErrorMsg?.find((x) => {
                                    return x.field === 'endQtr';
                                  })?.message
                                : ''
                            }
                          />
                        </Grid>
                      </Grid>
                    </RadioGroup>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div
            className="col-4"
            style={{
              paddingTop: '10px',
            }}
          >
            <RadioGroupComponent
              data-testid="sortBy"
              id="sortBy"
              labelName="Sort By"
              required
              optionList={
                state?.selectedValue == 'Detail'
                  ? [
                      { name: 'Quarter', value: 'Quarter' },
                      { name: 'NDC', value: 'NDC' },
                    ]
                  : [
                      { name: 'Quarter', value: 'Quarter' },
                      { name: 'Manufacturer', value: 'Manufacturer' },
                    ]
              }
              defaultValue={state && state.sortBy}
              filterAction={(e) => handleOnChangeEvent(e, 'sortBy')}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div
            className="col-4"
            style={{ paddingLeft: '60px', marginTop: '70px' }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  color="primary"
                  name="allManufacturers"
                  onChange={checkManufacturer}
                  checked={state?.allManufacturers}
                  value={menuName}
                />
              }
              label="All Manufacturers"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          {!state?.allManufacturers && (
            <div
              className="hcpcs col-12 unallocated"
              style={{ paddingLeft: '15px', width: '76vw' }}
            >
              <TableGrid
                onSelectionChanged={onSelectionChanged}
                getSelectedRowData={getSelectedRowData}
                ref={gridRef}
                helpMessage
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
                columnDefs={manufacturersTableGrid}
                rowData={
                  !_.isEmpty(manufacturerList)
                    ? manufacturerList.sort((a, b) =>
                        a.mfgId > b.mfgId ? 1 : -1
                      )
                    : []
                }
                rowSelection="multiple"
                selectRowIndex={selectedRowIndexValue}
                rowMultiSelectWithClick
                fileName="Manufacturing List"
                data-testid="onEditingStopped"
                enterMovesDown
                suppressCellFocus
                singleClickEdit
                exportFile
                hideColumnsInPdf
                isScrollOn
                defaultColWidth={200}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 30) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HcpcsCodeClaimsPaid;
